'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _MessageParser = require('@/libs/MessageParser');

var _MessageParser2 = _interopRequireDefault(_MessageParser);

var _Html = require('@/libs/renderers/Html');

var _Html2 = _interopRequireDefault(_Html);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _state = require('./state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextId = 0;

var Message = function () {
    function Message(message, user) {
        (0, _classCallCheck3.default)(this, Message);

        this.id = extractMessageId(message) || nextId++;

        this.time = message.time || Date.now();
        this.server_time = message.server_time || this.time;
        this.nick = message.nick;
        this.message = message.message;
        this.tags = message.tags;
        this.type = message.type || 'message';
        this.type_extra = message.type_extra;
        this.ignore = false;
        this.mentioned_urls = [];
        this.html = '';

        this.template = message.template || null;

        this.bodyTemplate = message.bodyTemplate || null;
        this.isHighlight = false;

        Object.defineProperty(this, 'user', { value: user });
    }

    (0, _createClass3.default)(Message, [{
        key: 'render',
        value: function render() {
            _GlobalApi2.default.singleton().emit('message.render', { message: this });
            return this;
        }
    }, {
        key: 'toHtml',
        value: function toHtml(messageList) {
            if (this.html) {
                return this.html;
            }

            var showEmoticons = _state2.default.setting('buffers.show_emoticons') && !messageList.buffer.isSpecial();
            var userList = messageList.buffer.users;
            var useExtraFormatting = !messageList.buffer.isSpecial() && messageList.useExtraFormatting && this.type === 'privmsg';

            var blocks = (0, _MessageParser2.default)(this.message, { extras: useExtraFormatting }, userList);

            _state2.default.$emit('message.prestyle', { message: this, blocks: blocks });

            var content = (0, _Html2.default)(blocks, showEmoticons);

            this.mentioned_urls = blocks.filter(function (block) {
                return block.type === 'url';
            }).map(function (block) {
                return block.meta.url;
            });
            this.html = content;

            _state2.default.$emit('message.poststyle', { message: this, blocks: blocks });
            return this.html;
        }
    }]);
    return Message;
}();

exports.default = Message;


function extractMessageId(message) {
    if (!message.tags) {
        return undefined;
    }

    return message.tags.msgid || message.tags['draft/msgid'] || undefined;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Message"]
window._kiwi_exports.libs.Message = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/Message.js
// module id = 7p2c
// module chunks = 1